'use strict';

import { environment } from '@quartz-iam-legacy/environments/environment';

angular.module('topBarControllers', [])
.provider('topBar', function () {

    this.config = {};

    this.$get = function () {
        return this;
    };

    this.setTitle = function (title) {
        this.config['title'] = title;
        this.config['icon'] = undefined;
    }

    this.setTitleAndIcon = function (title, icon) {
        this.config['title'] = title;
        this.config['icon'] = icon;
    }
})
.controller('TopBarController', ['$scope', 'topBar', 'authService', 'featureService', async function ($scope, topBar, authService, featureService) {
    $scope.config = topBar.config;

    $scope.logout = function () {
        authService.logout();
    };

    $scope.newIamUrl = environment.iamUrl;
    $scope.docsUrl = environment.docsUrl;
    $scope.hasDisplayCustomerLogoFeature = false;
    $scope.hasDocsFeature = false;

    featureService.hasFeature('DisplayCustomerLogo').then((hasDisplayCustomerLogoFeature) => {
        $scope.hasDisplayCustomerLogoFeature = hasDisplayCustomerLogoFeature;
    });

    featureService.hasFeature('IDDocusaurusDocs').then((hasDocsFeature) => {
        $scope.hasDocsFeature = hasDocsFeature;
    });
}]);
